const MONTHS_SHORT = [
  "",
  "янв",
  "фев",
  "мар",
  "апр",
  "май",
  "июн",
  "июл",
  "авг",
  "сен",
  "окт",
  "ноя",
  "дек",
];

const DAY_PART_LABELS = {
  morning: "утро",
  afternoon: "вечер",
};

export function moscowToday() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Moscow" });
}

export function formatShortDate(iso) {
  if (!iso || iso.length < 10) return "";
  return `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
}

export function formatRange(start, end) {
  return `${formatShortDate(start)}–${formatShortDate(end)}`;
}

export function defaultMonthIndex(year, todayStr) {
  if (todayStr.slice(0, 4) === String(year)) {
    return Number(todayStr.slice(5, 7)) - 1;
  }
  return 0;
}

export function unpaidCoversDate(leave, dateStr) {
  if (!leave?.start || !leave?.end || !dateStr) return false;
  return dateStr >= leave.start && dateStr <= leave.end;
}

export function cellUnpaidPart(leave, dateStr) {
  if (!unpaidCoversDate(leave, dateStr)) return null;
  return leave.day_part;
}

function parseIsoDate(value) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split("-").map(Number);
  return { year, month, day };
}

function formatDayMonth(dateParts) {
  return `${dateParts.day} ${MONTHS_SHORT[dateParts.month]}`;
}

export function formatUnpaidLeave(leave) {
  const start = parseIsoDate(leave?.start);
  const end = parseIsoDate(leave?.end);
  if (!start || !end) return "";

  if (leave.start === leave.end) {
    const base = formatDayMonth(start);
    if (leave.day_part === "morning" || leave.day_part === "afternoon") {
      return `${base} (${DAY_PART_LABELS[leave.day_part]})`;
    }
    return base;
  }

  if (start.month === end.month && start.year === end.year) {
    return `${start.day}–${end.day} ${MONTHS_SHORT[start.month]}`;
  }

  return `${formatDayMonth(start)} – ${formatDayMonth(end)}`;
}
